import DataGrid, {
    Column, Editing, FilterPanel,
    FilterRow,
    HeaderFilter,
    Lookup,
    Pager,
    Paging,
    Selection, Sorting
} from 'devextreme-react/data-grid';
import React, { useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { formRegisterApi } from '../../../api/formRegisterApi';
import { DefaultButton } from '../../../components/editor/button';
import { useCommonContext } from '../../../contexts/common';
import { showNotify } from '../../../helpers/toast';

const AttendanceModal = ({ dataSource, ts_form_items, onCancel, hanleReloadDataSource, chienDichs }) => {
    const { translate } = useCommonContext();
    const [isChangedValue, setIsChangedValue] = useState(false);

    const handleSaveChanges = async ({ id, is_attendanced, ket_qua_tra_chieu }) => {
        const res = await formRegisterApi.Attendance({
            id,
            is_attendanced,
            ket_qua_tra_chieu
        });
        if (!res.is_success) {
            showNotify({ type: "error", text: "Có lỗi xảy ra." });
            hanleReloadDataSource();
        } else {
            setIsChangedValue(true);
        }
    }
    return (
        <>
            <Modal open={true} size="large" dimmer={"blurring"} onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}>
                <Modal.Header>
                    <p>{translate('Cập nhật trạng thái điểm danh')}</p>
                </Modal.Header>
                <Modal.Content>
                    <form className="ui">
                        <DataGrid
                            keyExpr="id"
                            dataSource={dataSource}
                            columnHidingEnabled={false}
                            columnAutoWidth={true}
                            showBorders={true}
                            showColumnLines={false}
                            showRowLines={false}
                            rowAlternationEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode={'nextColumn'}
                            hoverStateEnabled={true}
                            focusedRowEnabled={false}
                            height={window.innerHeight - 220}
                            className="table-noborder-left"
                            noDataText={translate('Không có dữ liệu')}

                        >
                            <Editing
                                mode="cell"
                                allowUpdating={true}
                                allowAdding={false}
                                allowDeleting={false} />
                            <Column dataField="id" caption={'#Id'} allowEditing={false} width={100}></Column>
                            <Column dataField="is_attendanced" caption={'Đã điểm danh'} width={150} dataType="boolean"
                                setCellValue={(newData, value, currentRowData) => {
                                    // console.log({
                                    //     newData,
                                    //     value,
                                    //     currentRowData
                                    // });
                                    handleSaveChanges({ id: currentRowData.id, is_attendanced: value, ket_qua_tra_chieu: currentRowData.ket_qua_tra_chieu })
                                    newData.is_attendanced = value;
                                }}
                            ></Column>
                            <Column dataField="ket_qua_tra_chieu" caption={translate('Trà chiều')} width={200}
                                setCellValue={(newData, value, currentRowData) => {
                                    // console.log({
                                    //     newData,
                                    //     value,
                                    //     currentRowData
                                    // });
                                    handleSaveChanges({ id: currentRowData.id, is_attendanced: currentRowData.is_attendanced, ket_qua_tra_chieu: value })
                                    newData.ket_qua_tra_chieu = value;
                                }}
                            ></Column>
                            {/* <Column caption={"Data đăng ký"} alignment="center">
                                {ts_form_items.map((x) => {
                                    return (
                                        <Column
                                            key={x.id}
                                            dataField={`T_${x.id}`}
                                            caption={x.label}
                                            allowEditing={false}
                                        ></Column>
                                    );
                                })}
                            </Column> */}
                            <Column dataField="dm_chiendich_id" caption={translate('Chiến dịch')} width={150}>
                                <Lookup dataSource={chienDichs} valueExpr="id" displayExpr={"ten_chien_dich"} />
                            </Column>
                            <Column dataField="phone_number" caption={translate('Điện thoại')} minWidth={150}></Column>
                            <Column dataField="ho_ten" caption={translate('Họ tên')} width={150}></Column>
                            <Column dataField="email" caption={translate('Email')} width={150}></Column>
                            <Column dataField="ho_ten_hoc_sinh" caption={translate('Học sinh')} width={150}></Column>
                            <Column dataField="khoi_lop" caption={translate('Year')} width={100}>
                            </Column>

                            <Sorting mode="multiple" />
                            <Paging defaultPageSize={50} />
                            <Selection mode="single"></Selection>
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <HeaderFilter visible={true} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[10, 20, 50, 200, 500]}
                                infoText={`${translate('Trang')} {0} /{1} ({2} ${translate(
                                    'dòng'
                                )})`}
                                showInfo={true}
                            />
                        </DataGrid>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <DefaultButton text={"Đóng"} onClick={() => {
                            if (isChangedValue) {
                                hanleReloadDataSource();
                            }
                            onCancel();
                        }} />
                    </div>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default AttendanceModal;